import {
    ADD_POST,
    POST_LOADING,
    GET_POSTS,
    GET_POST,
    GET_POSTS_SCROLL,
    CLEAR_ERRORS,
    AUTH_LOADING,
    GET_ERRORS,
    DELETE_POST,
} from "../actions/types";
import axios from "axios";

//add post
export const addPost = (postData, history) => (dispatch) => {
    dispatch(clearErrors());
    dispatch(setAuthLoading());
    axios
        .post("/api/posts", postData)
        .then((res) => {
            dispatch({
                type: ADD_POST,
                payload: res.data,
            });
            // history.push("/home");
            dispatch(setAuthLoading());
            // dispatch(toggleForm());
        })
        .catch((err) => {
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
            dispatch(setAuthLoading());
        });
};
//get Post
export const getPosts = () => (dispatch) => {
    dispatch(setPostLoading());
    axios
        .get("/api/posts")
        .then((res) => {
            dispatch({
                type: GET_POSTS,
                payload: res.data,
            });
            dispatch(setPostLoading());
        })
        .catch((err) => {
            dispatch({
                type: GET_POSTS,
                payload: null,
            });
            dispatch(setPostLoading());
        });
};

// Get Post
export const getPost = (id) => (dispatch) => {
    dispatch(setPostLoading());
    axios
        .get(`/api/posts/${id}`)
        .then((res) => {
            dispatch({
                type: GET_POST,
                payload: res.data,
            });
            dispatch(setPostLoading());
        })
        .catch((err) => {
            dispatch({
                type: GET_POST,
                payload: null,
            });
            dispatch(setPostLoading());
        });
};

export const updatePost = (postData) => (dispatch) => {
    // dispatch(setProfileLoading());
    axios
        .post("/api/posts/update", postData)
        .then((res) => {
            // dispatch(setProfileLoading());
            dispatch(getPost(postData.id));
        })
        .catch((err) => {
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            });
            // dispatch(setProfileLoading());
        });
};
export const setAuthLoading = () => {
    return {
        type: AUTH_LOADING,
    };
};

//Delete post
export const deletePost = (id) => (dispatch) => {
    axios
        .delete(`/api/posts/${id}`)
        .then((res) =>
            dispatch({
                type: DELETE_POST,
                payload: id,
            })
        )
        .catch((err) =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data,
            })
        );
};

//add comment

//set post loading

export const setPostLoading = () => {
    return {
        type: POST_LOADING,
    };
};

//get Post Scroll
export const getPostScroll = (page) => (dispatch) => {
    dispatch(setPostLoading());
    axios
        .get(`api/posts/pagination/post?page=${page}&limit=8`)
        .then((res) => {
            dispatch({
                type: GET_POSTS_SCROLL,
                payload: res.data,
            });

            dispatch(setPostLoading());
        })
        .catch((err) => {
            console.log(err);
            dispatch(setPostLoading());
        });
};

export const clearErrors = () => {
    return {
        type: CLEAR_ERRORS,
    };
};
